module.exports = __webpack_public_path__ + "static/media/cg0.f1a683fe.jpg";